// it's used to mount subscription client
export const rootElementSelector =
  '[data-clientside-hook~="subscriptionClientWrapper"]'

export const buyboxSubscriptionLinkSelector =
  '[data-clientside-hook~="buyboxSubscriptionLink"]'

export const buyboxSubscriptionLinkTriggerSelector =
  '[data-clientside-hook~="buyboxSubscriptionLink__trigger"]'

export const aboModalSubscriptionLinkSelector =
  '[data-clientside-hook~="aboModalSubscriptionLink"]'

export const aboModalSubscriptionLinkTriggerSelector =
  '[data-clientside-hook~="aboModalSubscriptionLink__trigger"]'

export const buyboxPersonalAdviceLinkSelector =
  '[data-clientside-hook~="buyboxPersonalAdviceLink"]'

export const productDescriptionPersonalAdviceLinkSelector =
  '[data-clientside-hook~="productDescriptionPersonalAdviceLink"]'

export const productLabelAboSelector =
  '[data-clientside-hook~="productLabelAbo"]'

export const headerAboLinkSelector =
  '.o-HeaderLarge__user-logged-in [data-clientside-hook~="headerAboLink"]'

export const loginFormErrorNotificationSelector =
  '[data-clientside-hook~="loginModalErrorNotification"]'

export const loginFormDescriptionSelector =
  '[data-clientside-hook~="loginModalDescription"]'

export const productListAboSubscriptionLinkSelector =
  '[data-clientside-hook~="productListAboSubscriptionLink"]'
